import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { alpineHeaderThemes, alpineTheme } from './themes';

export const AlpineThemeGrid = ({
  setGridReference,
  columnDefs,
  rowData,
  onCellEditingStopped,
  onCellEditingStarted,
  headerHeight,
  headerBgColor,
}) => {
  const onGridReady = (params) => {
    setGridReference(params);
  };

  return (
    <div style={{ width: '100%', maxHeight: '500px' }}>
      <AgGridReact
        theme={alpineHeaderThemes[headerBgColor] ?? alpineTheme}
        columnMenu="legacy"
        columnDefs={columnDefs}
        rowData={rowData}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridReady={onGridReady}
        onCellEditingStopped={onCellEditingStopped}
        onCellEditingStarted={onCellEditingStarted}
        headerHeight={headerHeight}
      />
    </div>
  );
};
